import React from "react";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { ButtonLike } from "../../../../../../shared/ui/ButtonLike/ButtonLike";
import { ReqomendationsList } from "../../../../../../types";
import { Avatar, Button, ListItemAvatar } from "@mui/material";
import cardImg from "../../../../../../assets/images/studyCardImg.png";
import { useNavigate } from "react-router-dom";

interface CourseRecommendationListProps {
  recommendationsList: ReqomendationsList | undefined;
}

export const CourseRecommendationList = ({
  recommendationsList,
}: CourseRecommendationListProps) => {
  const navigate = useNavigate();
  if (!recommendationsList) return null;
  return (
    <div>
      <Typography
        sx={{
          padding: "64px 0 32px 0",
          fontWeight: 800,
          fontSize: "24px",
        }}
        variant="h5"
        component="h2">
        Также покупают:
      </Typography>
      <List>
        {recommendationsList?.items?.map((item) => (
          <Paper
            key={item.id}
            elevation={2}
            style={{
              position: "relative",
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              borderRadius: "8px",
              cursor: "pointer",
            }}>
            <ListItemAvatar>
              <Avatar
                variant="square"
                src={cardImg}
                alt="Course Image"
                style={{
                  width: "180px",
                  height: "120px",
                  marginRight: "20px",
                  borderBottomLeftRadius: "8px",
                  borderTopLeftRadius: "8px",
                }}
              />
            </ListItemAvatar>
            <div
              style={{ flex: 1 }}
              onClick={() => navigate(`/course/${item.id}`)}>
              <ListItemText
                primary={item.name}
                secondary={`${item.fullname_teacher}`}
                primaryTypographyProps={{
                  style: { fontWeight: "bold", fontSize: "14px" },
                }}
                secondaryTypographyProps={{ style: { color: "#555" } }}
              />
              <ListItemText
                primary={`${item.price.toLocaleString()} ₸`}
                primaryTypographyProps={{
                  style: {
                    fontWeight: "bold",
                    flexWrap: "wrap",
                    fontSize: "18px",
                  },
                }}
                secondaryTypographyProps={{ style: { color: "#555" } }}
              />
            </div>
            <div style={{ position: "absolute", top: "16px", right: "16px" }}>
              <ButtonLike />
            </div>
          </Paper>
        ))}
      </List>
      {recommendationsList?.total > recommendationsList?.limit && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "20px 0",
          }}>
          <Button
            color="primary"
            variant="contained"
            sx={{ height: "50px" }}
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/search");
            }}>
            Смотреть все курсы
          </Button>
        </div>
      )}
    </div>
  );
};
